<template>
  <v-flex
    :class="schema.refSpecs != null ? '' : layoutClass"
    v-bind="schema.layout"
  >
    <!-- Leafs -->
    <div
      v-if="
        schema.type === 'div' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      style="height:1px"
    ></div>
    <div
      v-if="
        schema.type === 'title' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
    >
      <h3 v-if="schema.class == null || schema.class.trim() === ''">
        {{ schema.label }}
      </h3>
      <span v-else :class="schema.class" v-bind="schema">{{
        schema.label
      }}</span>
    </div>
    <TimePicker
      v-if="
        schema.type === 'time-picker' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      :schema="schema"
    ></TimePicker>

    <CustomTableWidget
      v-else-if="
        schema.type === 'custom-table' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      @buttonClicked="$emit('buttonClicked', $event)"
      @indexChange="$emit('indexChange', [$event, inputKey])"
    ></CustomTableWidget>

    <LineChart
      v-else-if="
        schema.type === 'line-chart' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :query-id="schema.queryId"
      :title="schema.title"
      :xtitle="schema.xtitle"
      :ytitle="schema.ytitle"
      :label="schema.label"
      :y-min="schema.yMin"
      :y-max="schema.yMax"
      :x-min-ticks="schema.xMinTicks"
      :x-max-ticks="schema.xMaxTicks"
      :style-chart="schema.style"
    ></LineChart>

    <BarChart
      v-else-if="
        schema.type === 'bar-chart' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :query-id="schema.queryId"
      :title="schema.title"
      :xtitle="schema.xtitle"
      :ytitle="schema.ytitle"
      :label="schema.label"
      :y-min="schema.yMin"
      :y-max="schema.yMax"
      :x-min-ticks="schema.xMinTicks"
      :x-max-ticks="schema.xMaxTicks"
    ></BarChart>

    <DoughnutChart
      v-else-if="
        schema.type === 'doughnut-chart' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :query-id="schema.queryId"
      :title="schema.title"
      :tooltip-partener="schema.tooltipPartener"
      :tooltip-nr-doc="schema.tooltipNrDoc"
      :tooltip-percent="schema.tooltipPercent"
    ></DoughnutChart>

    <RadarChart
      v-else-if="
        schema.type === 'radar-chart' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :label="schema.label"
      :query-id="schema.queryId"
      :title="schema.title"
    ></RadarChart>

    <PieChart
      v-else-if="
        schema.type === 'pie-chart' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :query-id="schema.queryId"
      :title="schema.title"
      :tooltip-partener="schema.tooltipPartener"
      :tooltip-nr-doc="schema.tooltipNrDoc"
      :tooltip-percent="schema.tooltipPercent"
    ></PieChart>

    <ScatterChart
      v-else-if="
        schema.type === 'scatter-chart' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :query-id="schema.queryId"
      :title="schema.title"
      :xtitle="schema.xtitle"
      :ytitle="schema.ytitle"
      :label="schema.label"
      :y-min="schema.yMin"
      :y-max="schema.yMax"
      :x-min-ticks="schema.xMinTicks"
      :x-max-ticks="schema.xMaxTicks"
      :style-chart="schema.style"
    ></ScatterChart>

    <PolarAreaChart
      v-else-if="
        schema.type === 'polar-area-chart' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :query-id="schema.queryId"
      :title="schema.title"
      :tooltip-partener="schema.tooltipPartener"
      :tooltip-nr-doc="schema.tooltipNrDoc"
      :tooltip-percent="schema.tooltipPercent"
    ></PolarAreaChart>

    <ChartsTable
      v-else-if="
        schema.type === 'charts-table' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :query-id="schema.queryId"
      :title="schema.title"
      :selected-header="schema.selectedHeader"
      :selected-value="schema.selectedValue"
    ></ChartsTable>

    <CustomTableDialogue
      v-else-if="
        schema.type === 'custom-table-dialogue' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      :schema="schema"
      @buttonClicked="$emit('buttonClicked', $event)"
      @indexChange="$emit('indexChange', [$event, inputKey])"
    ></CustomTableDialogue>

    <AttachmentWidget
      v-else-if="
        schema.type === 'attachment' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      :schema="schema"
      :entity-id="currentEntityId"
      :entry-id="currentEntryId"
      @buttonClicked="$emit('buttonClicked', $event)"
      @indexChange="$emit('indexChange', [$event, inputKey])"
      @iconClicked="$emit('iconClicked', [$event, inputKey])"
    ></AttachmentWidget>

    <AddressWidget
      v-else-if="
        schema.type === 'address' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      v-bind="schema"
      :readonly="schema.readonly"
      :show-minimum-address="schema.showMinimumAddress"
      :required="schema.required"
      :header="schema.header"
      @refShowList="$emit('refShowList')"
      @refClearSelection="$emit('refClearSelection')"
    ></AddressWidget>

    <SelectWidget
      v-else-if="
        schema.type === 'select' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      :schema="schema"
      @transmit="transmit"
      @getItems="getItems"
      @hide="hide"
      @show="show"
      @make-readonly="makeReadonly"
    ></SelectWidget>

    <PdfGeneratorWidget
      v-else-if="
        schema.type === 'pdfGenerator' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :entry-id="currentEntryId"
      :entity-id="currentEntityId"
    ></PdfGeneratorWidget>

    <QueryTableWidget
      v-else-if="
        schema.type === 'query-table' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :query-id="schema.queryId"
      @iconClicked="$emit('iconClicked', [$event, inputKey])"
    ></QueryTableWidget>

    <TableWidget
      v-else-if="
        schema.type === 'table' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      @buttonClicked="$emit('buttonClicked', $event)"
      @indexChange="$emit('indexChange', [$event, inputKey])"
      @iconClicked="$emit('iconClicked', [$event, inputKey])"
    ></TableWidget>

    <CheckBoxWidget
      v-else-if="
        schema.type === 'checkbox' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      :schema="schema"
      @hide="hide"
      @show="show"
      @make-readonly="makeReadonly"
    ></CheckBoxWidget>

    <RadioGroupWidget
      v-else-if="
        schema.type === 'radiogroup' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      :schema="schema"
      @hide="hide"
      @show="show"
      @make-readonly="makeReadonly"
    ></RadioGroupWidget>

    <DateWidget
      v-else-if="
        schema.type === 'date' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      v-bind="schema"
      :schema="schema"
    ></DateWidget>

    <TextWidget
      v-else-if="
        schema.type === 'text' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      v-bind="schema"
      :label="schema.label"
      :suggestions="schema.suggestions"
      :schema="schema"
      :entity-id="currentEntityId"
      :widget-key="inputKey"
      clearable
      @transmit="transmit"
      @hide="hide"
      @show="show"
      @make-readonly="makeReadonly"
      @refShowList="$emit('refShowList')"
      @refClearSelection="$emit('refClearSelection')"
    ></TextWidget>

    <!-- !!! Nu are v-model pentru ca doar afiseaza date -->
    <TextWidget
      v-else-if="
        schema.type === 'sequence' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
      :label="schema.label"
      :value="currentInput[inputKey]"
      readonly
    />

    <SelectFromFunctionWidget
      v-else-if="
        schema.type === 'function' &&
          schema.widgetType === 'select' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :key="updates"
      v-model="currentInput[inputKey]"
      v-bind="schema"
      :entity-id="currentEntityId"
      :entry-id="currentEntryId"
      @input="handleInput"
      @hide="hide"
      @show="show"
      @make-readonly="makeReadonly"
      @refShowList="$emit('refShowList')"
      @refClearSelection="$emit('refClearSelection')"
    ></SelectFromFunctionWidget>

    <!-- !!! Nu are v-model pentru ca doar afiseaza date -->
    <FunctionWidget
      v-else-if="
        schema.type === 'function' &&
          schema.widgetType === undefined &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :key="updates"
      v-bind="schema"
      :entity-id="currentEntityId"
      :entry-id="currentEntryId"
      :function-name="schema.functionName"
      :function-args="schema.functionArgs"
      @hide="hide"
      @show="show"
      @make-readonly="makeReadonly"
      @refShowList="$emit('refShowList')"
      @refClearSelection="$emit('refClearSelection')"
    ></FunctionWidget>

    <NumberWidget
      v-else-if="
        schema.type === 'number' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      v-bind="schema"
      :schema="schema"
      clearable
      @transmit="transmit"
      @refShowList="$emit('refShowList')"
      @refClearSelection="$emit('refClearSelection')"
    ></NumberWidget>

    <ColorPickerWidget
      v-else-if="
        schema.type === 'color' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
    ></ColorPickerWidget>

    <DividerWidget
      v-else-if="
        schema.type === 'divider' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
    ></DividerWidget>

    <SelectOneOfWidget
      v-else-if="
        schema.type === 'list' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :schema="schema"
    ></SelectOneOfWidget>

    <v-subheader v-else-if="schema.type === 'subheader'" v-bind="schema">{{
      schema.label
    }}</v-subheader>

    <!-- Complex/recursive widgets -->
    <!-- Row/Column containers -->

    <ChildEntityDataWidget
      v-else-if="
        schema.type === 'child-entity-data' &&
          currentEntityId != null &&
          currentEntryId != null &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :query-id="schema.queryId"
      :parent-entity-id="currentEntityId"
      :parent-entry-id="currentEntryId"
      :child-entity-id="schema.childEntityId"
      :crud-form-redirect="schema.crudFormRedirect"
      :query-hard-filters-on-top="schema.queryHardFiltersOnTop"
      :hard-filters="schema.hardFilters"
      :refresh-form="schema.refreshForm"
      :header="schema.header"
      :on-add-redirect-to-update="schema.onAddRedirectToUpdate"
      :button-style="schema.buttonStyle"
      @refreshFormRequested="handleRefreshFormRequest"
      @refreshRequested="handleRefreshRequests"
    ></ChildEntityDataWidget>

    <!-- RefWidget start -->

    <RefWidget
      v-else-if="
        schema.type === 'ref' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      v-model="currentInput[inputKey]"
      v-bind="schema"
      @buttonClicked="$emit('buttonClicked', $event)"
      @validate="updateIsValid"
      @refreshRequested="handleRefreshRequests"
    ></RefWidget>

    <!-- RefWidget end -->

    <MultiRefWidget
      v-else-if="
        schema.type === 'multi-ref' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :key="updates"
      v-model="currentInput[inputKey]"
      v-bind="schema"
      :parent-entry-id="currentEntryId"
    />

    <SelectEntityWidget
      v-else-if="schema.type === 'select-entity'"
      v-model="currentInput"
      v-bind="schema"
    />

    <OneOfRefWidget
      v-else-if="
        schema.type === 'one-of-ref' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      :key="updates"
      v-model="currentInput[inputKey]"
      v-bind="schema"
    />

    <v-layout
      v-else-if="['row', 'column'].indexOf(schema.type) > -1"
      v-bind="schema"
    >
      <RDWidget
        v-for="(item, key) in schema.children"
        :key="key"
        :input-key="key"
        :schema="item"
      ></RDWidget>
    </v-layout>

    <v-layout
      v-else-if="
        schema.type === 'dialog' &&
          (schema.hidden === undefined || schema.hidden === false)
      "
      row
      justify-center
    >
      <v-dialog v-model="showDialog">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">{{
            schema.showDialogBtnText
          }}</v-btn>
        </template>
        <v-card>
          <v-card-title>Dialog</v-card-title>
          <v-card-text>
            <v-container>
              <v-layout wrap>
                <RDWidget
                  v-for="(item, key) in schema.innerSchema"
                  :key="key"
                  :input-key="key"
                  :schema="item"
                  @indexChange="$emit('indexChange', $event)"
                ></RDWidget>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>

    <div v-else-if="schema.type === 'complex' && schema.children !== null">
      <RDWidget
        v-for="(item, key) in schema.children"
        :key="key"
        :input-key="key"
        :schema="item"
      ></RDWidget>
    </div>
  </v-flex>
</template>

<script>
import SelectOneOfWidget from './leaf_widgets/SelectOneOfWidget.vue'
import DateWidget from './leaf_widgets/DateWidget.vue'
import TextWidget from './leaf_widgets/TextWidget.vue'
import NumberWidget from './leaf_widgets/NumberWidget.vue'
import ColorPickerWidget from './leaf_widgets/ColorPickerWidget.vue'
import SelectWidget from './leaf_widgets/SelectWidget.vue'
import CheckBoxWidget from './leaf_widgets/CheckBoxWidget.vue'
import RadioGroupWidget from './leaf_widgets/RadioGroupWidget.vue'
import TableWidget from './leaf_widgets/TableWidget.vue'
import TimePicker from './leaf_widgets/TimePicker.vue'
import AddressWidget from './complex_widgets/AddressWidget.vue'
import CustomTableWidget from './complex_widgets/CustomTableWidget.vue'
import RefWidget from './complex_widgets/RefWidget.vue'
import CustomTableDialogue from './leaf_widgets/CustomTableDialogue.vue'
import AttachmentWidget from './complex_widgets/AttachmentWidget.vue'
import QueryTableWidget from './leaf_widgets/QueryTableWidget.vue'
import ChildEntityDataWidget from './complex_widgets/ChildEntityDataWidget.vue'
import DividerWidget from './leaf_widgets/DividerWidget.vue'
import PdfGeneratorWidget from './leaf_widgets/PdfGeneratorWidget.vue'
import MultiRefWidget from './complex_widgets/MultiRefWidget.vue'
import SelectEntityWidget from './complex_widgets/SelectEntityWidget.vue'
import OneOfRefWidget from './complex_widgets/OneOfRefWidget.vue'
import LineChart from './leaf_widgets/Charts/LineChart.vue'
import BarChart from './leaf_widgets/Charts/BarChart.vue'
import DoughnutChart from './leaf_widgets/Charts/DoughnutChart.vue'
import RadarChart from './leaf_widgets/Charts/RadarChart.vue'
import PieChart from './leaf_widgets/Charts/PieChart.vue'
import ScatterChart from './leaf_widgets/Charts/ScatterChart.vue'
import PolarAreaChart from './leaf_widgets/Charts/PolarAreaChart.vue'
import ChartsTable from './leaf_widgets/ChartsTable'

export default {
  name: 'RDWidget',
  components: {
    DateWidget,
    TextWidget,
    NumberWidget,
    ColorPickerWidget,
    SelectWidget,
    SelectOneOfWidget,
    CheckBoxWidget,
    RadioGroupWidget,
    TableWidget,
    TimePicker,
    AddressWidget,
    CustomTableWidget,
    RefWidget,
    CustomTableDialogue,
    AttachmentWidget,
    QueryTableWidget,
    ChildEntityDataWidget,
    DividerWidget,
    FunctionWidget: () => import('./leaf_widgets/function/FunctionWidget.vue'),
    PdfGeneratorWidget,
    MultiRefWidget,
    SelectEntityWidget,
    OneOfRefWidget,
    SelectFromFunctionWidget: () =>
      import('./leaf_widgets/function/SelectFromFunctionWidget.vue'),
    LineChart,
    BarChart,
    DoughnutChart,
    RadarChart,
    PieChart,
    ScatterChart,
    PolarAreaChart,
    ChartsTable
  },
  props: {
    schema: {
      type: Object,
      required: true
    },
    entityId: {
      type: String,
      default: null
    },
    inputKey: {
      type: String,
      required: true
    },
    currentEntityId: {
      type: String,
      default: null
    },
    currentEntryId: {
      type: String,
      default: null
    },
    addButtonClicked: {
      type: Number,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    layoutClass: {
      type: String,
      default: 'px-3'
    }
  },
  data() {
    return {
      showDialog: false,
      searchDialogue: false,
      currentInput: this.value != null ? this.value : null,
      auxRow: this.schema.values || {},
      selected: [],
      pagination: {
        sortBy: 'name'
      },
      isValid: true,
      updates: 0
    }
  },
  watch: {
    currentIntput: {
      deep: true,
      handler: function() {
        //console.log("RDWiget-Value_Watch");
        this.$emit('input', this.value)
      }
    }
  },
  methods: {
    forceUpdate: function() {
      // console.log("Force updating: " + this.inputKey);
      this.$forceUpdate()
      this.updates++
    },
    updateIsValid: function(validationState) {
      this.isValid = validationState
      this.$emit('validateComplexWidget', validationState, this.inputKey)
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    hide(schema, value) {
      this.$emit('hide', schema, value)
    },
    show(schema, value) {
      this.$emit('show', schema, value)
    },
    makeReadonly(schema, value) {
      this.$emit('make-readonly', schema, value)
    },
    transmit(comp, value) {
      this.$emit('transmit', comp, value)
    },
    getItems(url, comp) {
      this.$emit('getItems', url, comp)
    },
    handleRefreshRequests({ targets, invokerSnapshot }) {
      console.log('refresh requested from: ' + this.inputKey)
      this.$emit(
        'refreshRequested',
        targets || this.schema.refreshTargets,
        this.inputKey,
        invokerSnapshot
      )
    },
    handleRefreshFormRequest() {
      this.$emit('refreshFormRequested')
    },
    handleInput(value) {
      // console.log(
      //   "handle input called for widget: " + this.inputKey + " value: " + value
      // );
      if (
        this.schema.refreshTargets != null &&
        Array.isArray(this.schema.refreshTargets)
      ) {
        this.$emit(
          'refreshRequested',
          this.schema.refreshTargets,
          this.inputKey,
          value
        )
      }
    }
  }
}
</script>
